import React, { ReactNode } from 'react';
import { styled } from '@mui/material';

const classesPrefix = 'pageHeader';

const classes = {
    headerContainer: `${classesPrefix}-headerContainer`,
};

const StyledDiv = styled('div')(({ theme }) => {
    return {
        [`&.${classes.headerContainer}`]: {
            backgroundColor: theme.palette.primary.main,
            position: 'sticky',
            top: 0,
            zIndex: theme.zIndex.speedDial - 1,
        },
    };
});

const PageHeader = ({
    children,
}: {
    children?: ReactNode;
}): React.JSX.Element => {
    return (
        <StyledDiv id='header-container' className={classes.headerContainer}>
            {children}
        </StyledDiv>
    );
};

export default PageHeader;
